import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AnnotationConfig } from '../../annotations/shared/annotation-config';
import { AnnotatorConfig } from '../../annotations/shared/annotator-config';
import { EntityType } from '../../rl-common/shared/shared/entity-type.enum';
import { SubmissionService } from '../core/submission.service';
import { Assignment } from '../shared/assignment';
import { StudentSubmission } from '../shared/student-submission';
import { Submission } from '../shared/submission';

@Component({
  selector: 'rl-submission-view',
  templateUrl: './submission-view.component.html',
  styleUrls: ['./submission-view.component.scss', './submission-view.component-rtl.css']
})
export class SubmissionViewComponent implements OnInit {

  @Input('assignment') asgmt : Assignment;
  @Input() showNext : boolean;
  @Input() set studentSubmission(sub : StudentSubmission){
    if(this.annotator) this.annotator.mainAnnotationConfig = new AnnotationConfig(sub.submission.id, EntityType.SUBMISSION);
    this.sub = sub;
    this.reset();
  }

  @Output() onSave = new EventEmitter<{oldSub : Submission, newSub : Submission}>();
  @Output() onNext = new EventEmitter<void>();
  
  @ViewChild('gradingForm', {read : NgForm}) gradingForm : NgForm;
  
  sub : StudentSubmission;
  copySub : Submission;
  annotator : AnnotatorConfig;

  constructor(private submissionService : SubmissionService) { }

  ngOnInit(): void {
    this.annotator = this.submissionService.getAnnotationsConfig();
    this.annotator.commentsConfig.visibility = "public";
    this.annotator.additionalAnnotationConfig = [new AnnotationConfig(this.asgmt.id, EntityType.ASSIGNMENT)];
    if(this.sub) this.annotator.mainAnnotationConfig = new AnnotationConfig(this.sub.submission.id, EntityType.SUBMISSION);
  }

  hasChanges = () => this.gradingForm?.form.dirty;

  save = (moveTo? : 'next' | 'prev') => {
    let oldSub = this.sub.submission;
    this.sub.submission = this.copySub;
    this.submissionService.save(this.sub.submission).subscribe(s => {
      this.sub.submission = s;
      if(this.onSave.observers?.length) this.onSave.emit({oldSub : oldSub, newSub : s});
      if(!moveTo) this.reset();
      if(moveTo == 'next') this.onNext?.emit();
    });
  }

  reset = () => {
    this.copySub = Object.assign({}, this.sub.submission);
    if(this.gradingForm) this.gradingForm.resetForm(this.copySub);
  }

  validateInput = (score : number) : boolean => score <= this.asgmt.lmsAssignmentMaxScore && score >= 0;
  
}
